/**
 * Simple logger that only outputs in development mode.
 * In production, errors are sent to Sentry instead.
 */
import * as Sentry from '@sentry/react';

const isDev = process.env.NODE_ENV === 'development';

export const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },

  warn: (...args) => {
    if (isDev) console.warn(...args);
  },

  error: (message, error, context = {}) => {
    if (isDev) {
      console.error(message, error, context);
    } else {
      // Send to Sentry in production
      Sentry.captureException(error, {
        extra: { message, ...context },
      });
    }
  },

  // For debugging specific features - can be toggled
  debug: (feature, ...args) => {
    if (isDev) console.log(`[${feature}]`, ...args);
  },
};

export default logger;
